import { mutatorAction } from 'satcheljs';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';
import getScenarioStore from '../selectors/getScenarioStore';

export default mutatorAction(
    'setSearchSessionGuid',
    (searchSessionGuid: string, scenarioId: SearchScenarioId): void => {
        getScenarioStore(scenarioId).searchSessionGuid = searchSessionGuid;
    }
);
